import { useState } from "react";

import Spinner from "./Spinner";
import { getThreadIdFromTweet } from "./apiService";

function UnrollTweetForm(props) {
  const { placeholder, invalidateCache, existingThreadId, callback } = props;

  const [tweetUrl, setTweetUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const tweetIdMatch = tweetUrl.match(/(\d+)(?:\?s=20)?$/);

    if (tweetIdMatch.length < 1) {
      setError("Please enter a valid tweet URL");
      return;
    }

    const tweetId = tweetIdMatch[1];

    setError(null);
    setLoading(true);

    const response = await getThreadIdFromTweet(
      tweetId,
      invalidateCache,
      existingThreadId
    );

    setLoading(false);

    if (response.error) {
      console.error(response.error);
      setError(response.error);
      return;
    }

    setTweetUrl("");

    callback(response);
  };

  return (
    <div className="flex flex-col items-center">
      <form
        className="w-full flex flex-col items-center sm:flex-row justify-between mb-8"
        onSubmit={handleSubmit}
      >
        <input
          type="text"
          placeholder={placeholder}
          onChange={(e) => setTweetUrl(e.target.value)}
          className="w-full sm:w-4/6 text-sm shadow-md rounded-md px-2 py-2 mb-2 sm:mb-0"
        />

        <button
          type="submit"
          className="bg-white w-32 shadow-md rounded-md py-2 font-bold text-white bg-indigo-500 w-full sm:w-32"
        >
          Unroll
        </button>
      </form>

      {loading ? (
        <div className="">
          <Spinner />
        </div>
      ) : null}

      {error && (
        <p className="w-11/12 sm:w-3/4 max-w-screen-md mb-4 text-left">
          {error}
        </p>
      )}
    </div>
  );
}

export default UnrollTweetForm;
